// extracted by mini-css-extract-plugin
export default {"products":"Mz-z","card":"Nz-z","oosMessaging":"Oz-z"};